/* eslint-disable import/prefer-default-export */
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledButtonGroup = styled(Button)`
    background-color: #fafafa;
    border-color: #f2f2f2;
`;
